module.exports = __webpack_public_path__ + "img/customer-a-043.77fcba3a.png";